import React, { useEffect, useRef } from 'react';

import { BreakpointSizeType } from '../../../../theme/type/breakpoints-type';
import { GapSizeType } from '../../../../theme/type/gap-type';
import { cn, marginBottomClass } from '../../../../utils/tailwind';

const mobileBreakUnderClass: Record<BreakpointSizeType, string> = {
    xs: 'xs:-mx-vsmall xs:min-w-[calc(100%_+_3rem)] max-xs:!overflow-x-visible max-xs:[&_th]:w-full max-xs:[&_th]:min-w-full max-xs:[&_td]:w-full max-xs:[&_td]:min-w-full',
    vs: 'vs:-mx-vsmall vs:min-w-[calc(100%_+_3rem)] max-vs:!overflow-x-visible max-vs:[&_th]:w-full max-vs:[&_th]:min-w-full max-vs:[&_td]:w-full max-vs:[&_td]:min-w-full',
    sm: 'sm:-mx-vsmall sm:min-w-[calc(100%_+_3rem)] max-sm:!overflow-x-visible max-sm:[&_th]:w-full max-sm:[&_th]:min-w-full max-sm:[&_td]:w-full max-sm:[&_td]:min-w-full',
    md: 'md:-mx-vsmall md:min-w-[calc(100%_+_3rem)] max-md:!overflow-x-visible max-md:[&_th]:w-full max-md:[&_th]:min-w-full max-md:[&_td]:w-full max-md:[&_td]:min-w-full',
    lg: 'lg:-mx-vsmall lg:min-w-[calc(100%_+_3rem)] max-lg:!overflow-x-visible max-lg:[&_th]:w-full max-lg:[&_th]:min-w-full max-lg:[&_td]:w-full max-lg:[&_td]:min-w-full',
    vl: 'vl:-mx-vsmall vl:min-w-[calc(100%_+_3rem)] max-vl:!overflow-x-visible max-vl:[&_th]:w-full max-vl:[&_th]:min-w-full max-vl:[&_td]:w-full max-vl:[&_td]:min-w-full',
    xl: 'xl:-mx-vsmall xl:min-w-[calc(100%_+_3rem)] max-xl:!overflow-x-visible max-xl:[&_th]:w-full max-xl:[&_th]:min-w-full max-xl:[&_td]:w-full max-xl:[&_td]:min-w-full',
    xxl: 'xxl:-mx-vsmall xxl:min-w-[calc(100%_+_3rem)] max-xxl:!overflow-x-visible max-xxl:[&_th]:w-full max-xxl:[&_th]:min-w-full max-xxl:[&_td]:w-full max-xxl:[&_td]:min-w-full',
    fullhd: 'fullhd:-mx-vsmall fullhd:min-w-[calc(100%_+_3rem)] max-fullhd:!overflow-x-visible max-fullhd:[&_th]:w-full max-fullhd:[&_th]:min-w-full max-fullhd:[&_td]:w-full max-fullhd:[&_td]:min-w-full',
};

export interface TableContainerPropsInterface {
    children: React.ReactElement;
    mobileBreakUnder?: BreakpointSizeType;
    onScrollCallback: (e: React.UIEvent<HTMLDivElement, UIEvent>) => void;
    onLoadCallback: (e: HTMLDivElement | null) => void;
    containerOverflow: boolean;
    marginBottom: GapSizeType;
}

export const TableContainer: React.FC<TableContainerPropsInterface> = ({
    children,
    mobileBreakUnder,
    onScrollCallback,
    onLoadCallback,
    containerOverflow,
    marginBottom,
}) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        onLoadCallback(containerRef.current);
    }, [onLoadCallback]);

    const className = cn(
        'max-w-full border-0',
        marginBottomClass[marginBottom],
        containerOverflow && 'overflow-x-auto',
        mobileBreakUnder && mobileBreakUnderClass[mobileBreakUnder],
    );

    return (
        <div
            ref={containerRef}
            onScroll={(e: React.UIEvent<HTMLDivElement, UIEvent>) => onScrollCallback(e)}
            className={className}
        >
            {children}
        </div>
    );
};
